import { useState } from "react";

import "./style.scss";

const CopyTagUI = ({ label = "", copyLabel = "", className = "", icon = "pi-info-circle" }) => {
    const [copied, setCopied] = useState(false);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(copyLabel);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className={`copy-tag ${className}`}>
            <div className="copy-tag__label">
                <i className={`pi ${icon} copy-tag__icon`} />
                {label}
            </div>
            {copyLabel && (
                <div className="copy-tag__copy" onClick={copyToClipboard}>
                    {copied ? "Скопировано!" : copyLabel}
                    <i className="pi pi-copy copy-tag__copy-icon" />
                </div>
            )}
        </div>
    );
};

export default CopyTagUI;
